import { FC } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { padNumber } from "src/utility";
import ModuleTile from "../../ModuleTile/ModuleTile";
import { SectionLayoutProps } from "../Section.types";

const SectionWeb: FC<SectionLayoutProps> = ({ title, items, index, subtitle, icon, emblaRef }) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-6 py-4">
      <div className="flex h-full flex-1 flex-col items-start justify-start gap-3">
        <div>{icon}</div>
        <div className="leading-base text-font-active flex items-center gap-1 text-xs uppercase before:inline-block before:w-5 before:bg-current before:py-px before:content-['']">
          {t("Landing.categoryLabel", { number: padNumber(index + 1, 2) })}
        </div>
        <div className="text-3xl font-medium">{title}</div>
        <div className="text-sm text-font-subtle">{subtitle}</div>
      </div>
      <div ref={emblaRef} className="flex-3 overflow-hidden">
        <div
          className={classNames(
            "grid grid-flow-col grid-rows-1 items-center gap-4",
            items.length === 1 ? "grid-cols-1" : items.length === 2 ? "grid-cols-2" : "auto-cols-[calc(33%-8px)]",
          )}
        >
          {items.map((item) => (
            <div key={item.key} className="h-80">
              <ModuleTile item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionWeb;
